import { useMemo } from 'react';

import PropTypes from 'prop-types';

import AddToContactListModal from '#contactListFeature/components/AddToContactListModal/AddToContactListModal';

import { useLeadJobs } from '../../../../../contexts/LeadJobContext';
import { useLeadUI } from '../../../../../contexts/LeadUIContext';
import { useActionScope } from '../../../../../hooks/useActionScope';
import { useLeadUIStore } from '../../../../../stores/leadUIStore';
import { toLeadTableScope } from '../../../../../utils/toLeadTableScope';
import ExtendScrapingModal from '../ExtendScrapingModal/ExtendScrapingModal';

/**
 * Component grouping all modals and sidebars for the lead table
 * Handles all modal interactions in one place
 */
export const LeadTableModals = ({
	// Local props (not from context)
	showExtendModal,
	onCloseExtendModal,
	currentLeadCount,
	queryId,
	queryName,
	queryInput,
	queryTypeCode,
}) => {
	// Selection + mutation from context
	const { selectedContacts, hasLeadSelection, clearContactSelection, clearLeadSelection } = useLeadUI();
	const actionScope = useActionScope();
	// Stable identity: the modal's live preview refetches whenever its scope changes.
	const tableScope = useMemo(() => toLeadTableScope(actionScope), [actionScope]);

	// UI state directly from store
	const showEmailListModal = useLeadUIStore((s) => s.showEmailListModal);
	const setShowEmailListModal = useLeadUIStore((s) => s.setShowEmailListModal);

	const { handleExtendCompanySearch } = useLeadJobs();

	// Determine mode: lead-based (company selection) vs contact-based
	const isLeadMode = hasLeadSelection;

	return (
		<>
			{/* Modal to add contacts to contact list */}
			<AddToContactListModal
				isOpen={showEmailListModal}
				onClose={() => setShowEmailListModal(false)}
				{...(isLeadMode ? { tableScope } : { globalContactPersonIds: selectedContacts })}
				contactCount={isLeadMode ? actionScope.count : selectedContacts.length}
				onSuccess={() => {
					if (isLeadMode) {
						clearLeadSelection();
					} else {
						clearContactSelection();
					}
				}}
			/>

			{/* Extend Scraping Modal */}
			<ExtendScrapingModal
				isOpen={showExtendModal}
				onClose={onCloseExtendModal}
				onConfirm={handleExtendCompanySearch}
				currentCount={currentLeadCount}
				queryId={queryId}
				queryName={queryName}
				queryInput={queryInput}
				queryTypeCode={queryTypeCode}
			/>
		</>
	);
};

LeadTableModals.propTypes = {
	showExtendModal: PropTypes.bool.isRequired,
	onCloseExtendModal: PropTypes.func.isRequired,
	currentLeadCount: PropTypes.number.isRequired,
	queryId: PropTypes.string,
	queryName: PropTypes.string.isRequired,
	queryInput: PropTypes.object,
	queryTypeCode: PropTypes.string,
};
